/* ========== BAGBONDS THEME JS ========== */
(function(){
  // DRAWER (mobile nav)
  const burger = document.getElementById('bb-burger');
  const drawer = document.getElementById('bb-drawer');
  const backdrop = document.getElementById('bb-drawer-backdrop');
  function toggleDrawer(open){
    if(!burger||!drawer||!backdrop) return;
    burger.classList.toggle('open', open);
    drawer.classList.toggle('open', open);
    backdrop.classList.toggle('open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  }
  if(burger){
    burger.addEventListener('click', () => toggleDrawer(!drawer.classList.contains('open')));
    backdrop.addEventListener('click', () => toggleDrawer(false));
    drawer.querySelectorAll('a').forEach(a => a.addEventListener('click', () => toggleDrawer(false)));
  }

  // GALLERY (dot indicators + scroll tracking)
  const track = document.getElementById('bb-gallery-track');
  const dotsWrap = document.getElementById('bb-gallery-dots');
  if(track && dotsWrap){
    const slides = track.querySelectorAll('.bb-gallery-slide');
    slides.forEach((_, i) => {
      const d = document.createElement('button');
      d.className = 'bb-gallery-dot' + (i === 0 ? ' active' : '');
      d.setAttribute('aria-label', 'Poza ' + (i+1));
      d.addEventListener('click', () => {
        const s = slides[i];
        track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
      dotsWrap.appendChild(d);
    });
    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const center = track.scrollLeft + track.offsetWidth / 2;
        let best = 0, bestD = Infinity;
        slides.forEach((s, i) => {
          const c = s.offsetLeft + s.offsetWidth / 2;
          const d = Math.abs(c - center);
          if (d < bestD) { bestD = d; best = i; }
        });
        dotsWrap.querySelectorAll('.bb-gallery-dot').forEach((d, i) => d.classList.toggle('active', i === best));
      });
    }, { passive: true });
  }

  // FAQ accordion
  document.querySelectorAll('.bb-faq-item').forEach(item => {
    const q = item.querySelector('.bb-faq-q');
    if(q) q.addEventListener('click', () => item.classList.toggle('open'));
  });

  // STICKY BUY BAR (mobile)
  const sticky = document.getElementById('bb-sticky');
  const hero = document.getElementById('bb-hero');
  if(sticky && hero){
    function onScroll(){
      const past = window.scrollY > hero.offsetHeight * 0.6;
      const nearEnd = (window.innerHeight + window.scrollY) >= document.body.offsetHeight - 200;
      sticky.classList.toggle('show', past && !nearEnd);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();